import { Link } from "react-router-dom";
import type { Hold } from "../../../api/cityOrders";

interface Props {
  holds: Hold[];
  /** The office has overridden the holds that allow it, with a reason. */
  overridden: boolean;
}

/** What holds the City's PO from going on, dressed as the quote reader dresses
 * its issues. A hold that is about another PO on file links to it. */
export default function HoldList({ holds, overridden }: Props) {
  if (holds.length === 0) {
    return null;
  }
  return (
    <ul className="qr-issue-list">
      {holds.map((hold) => {
        const waived = overridden && hold.overridable;
        return (
          <li key={hold.code} className={`qr-issue ${waived ? "warning" : "blocking"}`}>
            <span className="qr-badge">{waived ? "overridden" : "blocking"}</span>
            <span>
              {hold.message}
              {hold.order_id !== null ? (
                <>
                  {" "}
                  <Link className="go-link" to={`/customer-orders/${hold.order_id}`}>
                    Open PO
                  </Link>
                </>
              ) : null}
            </span>
          </li>
        );
      })}
    </ul>
  );
}
